<nz-table #basicTable [nzBordered]="true" [nzData]="listOfData" [nzSize]="'small'" [nzShowPagination]="true"
    [nzFrontPagination]="false" nzServerRender nzOuterBordered nzSize="small" [nzPageSize]="pageSize"
    [nzPageIndex]="pageIndex" [nzLoading]="loading" [nzTotal]="total" (nzPageIndexChange)="onPageIndexChange($event)"
    [nzShowTotal]="totalTemplate">
    <thead>
        <tr>
            <th colspan="{{schema.columns.length}}" class="custom-header">{{schema.name}}</th>
        </tr>
        <tr>
            <th *ngFor="let col of schema.columns" [nzShowSort]="col.enableSort" [(nzSortOrder)]="sortOrder"
                (nzSortOrderChange)="onSort({ key: col.key, value: $event })" [nzWidth]="col.width">
                @if(col.enableSearch) {
                <div class="header-content">
                    <div>{{col.title}}</div>
                    @if(col.searchType=='input'){
                    <input nzAllowClear nz-input placeholder="Search {{col.title}}" [(ngModel)]="filters[col.key]"
                        (ngModelChange)="onFilterChange()" (click)="$event.stopPropagation()"
                        style="width: 70%; margin-top: 8px;" />
                    }
                    @else if (col.searchType=='select') {
                    <nz-select style="width: 70%; margin-top: 8px;" nzPlaceHolder="Search {{col.title}}" nzAllowClear
                        [(ngModel)]="filters[col.key]" (ngModelChange)="onFilterChange()">
                        <nz-option *ngFor="let option of col.option" [nzLabel]="option.text"
                            [nzValue]="option.value"></nz-option>
                    </nz-select>

                    }
                    @else if (col.searchType=='date') {
                    <nz-date-picker [(ngModel)]="filters[col.key]"
                        (ngModelChange)="onFilterChange($event)"></nz-date-picker>
                    }
                    @else if (col.searchType=='daterange') {
                    <nz-range-picker [(ngModel)]="filters[col.key]"
                        (ngModelChange)="onFilterChange($event)"></nz-range-picker>
                    }
                </div>
                }
                @else if (col.key=='action' && canShowAdd()) {
                <div class="header-content">
                    <div style="padding-top: 0.5rem;">
                        <button nz-tooltip nz-button nzTooltipTitle="Create New" nzPrimary (click)="onAdd()">
                            <nz-icon nzType="plus-circle" nzTheme="outline" />
                        </button>
                    </div>
                </div>
                }
                @else{
                <div class="header-content">
                    <div> {{ col.title }}</div>
                </div>
                }
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let data of listOfData;let i = index;">
            <td *ngFor="let col of schema.columns">
                <ng-container [ngSwitch]="col.type">
                    <!-- Text Columns -->
                    <span *ngSwitchCase="'autoGenerate'">{{ getSerialNo(i) }}</span>
                    <span *ngSwitchCase="'string'">{{ data[col.key] }}</span>
                    <span *ngSwitchCase="'image'"><img nz-image style="width: 75px;object-fit: contain;height: 100%;"
                            [nzSrc]="data[col.key]" alt="" />
                    </span>
                    <span *ngSwitchCase="'tag'">
                        <nz-tag [nzColor]="getTagColor(data[col.key])">{{ data[col.key] }}</nz-tag>
                    </span>

                    <span *ngSwitchCase="'number'">{{ data[col.key] }}</span>
                    <span *ngSwitchCase="'date'">{{ data[col.key] | date: 'dd-MM-yyyy HH:mm'}}</span>
                    <span *ngSwitchCase="'datearray'">{{ data[col.key] [0] | date: 'dd-MM-yyyy'}} ~ {{ data[col.key] [1]
                        | date: 'dd-MM-yyyy'}}</span>
                    <span *ngSwitchCase="'object'">{{ getCellValue(data,col.key)}}</span>
                    <ng-container *ngSwitchCase="'status'">
                        <nz-icon nzType="minus-square" *ngIf="data[col.key]==1" nzTheme="twotone" />
                        <nz-icon nzType="up-circle" *ngIf="data[col.key]==2" nzType="up-circle" nzTheme="twotone"
                            [nzTwotoneColor]="'#52c41a'" />
                        <nz-icon *ngIf="data[col.key]==3" nzType="down-circle" nzTheme="twotone"
                            [nzTwotoneColor]="'#ff4d4f'" />
                    </ng-container>

                    <!-- Action Button -->
                    <!-- <ng-container *ngSwitchCase="'button'">
                        <ng-container *ngFor="let label of col.label;" style="display: flex;">
                            <button nz-button [nzType]="label.type"
                                (click)="label.type ==='edit'?onEdit(data):showConfirm(data)" *ngIf="label?.isEnable"
                                [nzDanger]="label.isDanger">
                                <ng-container [ngSwitch]="label.type">
                                    <nz-icon nz-tooltip *ngSwitchCase="'edit'" nzTooltipTitle="Edit" nzType="edit"
                                        nzTheme="twotone" />
                                    <nz-icon nz-tooltip="Delete" *ngSwitchCase="'danger'" nzType="delete"
                                        nzTooltipTitle="Delete" [nzTwotoneColor]="'#ff4d4f'" nzTheme="twotone" />
                                </ng-container>
                            </button>
                            <nz-divider nzType="vertical"></nz-divider>
                        </ng-container>
                    </ng-container> -->
                    <ng-container *ngFor="let label of col.label">
                        <button nz-button [nzType]="label.type"
                            (click)="label.type === 'edit' ? onEdit(data) : label.type === 'gen' ? onGenerateResult(data) : onDelete(data)"
                            *ngIf="canShowLabel(label)" [nzDanger]="label.isDanger">
                            <ng-container [ngSwitch]="label.type">
                                <!-- Edit button -->
                                <nz-icon *ngSwitchCase="'edit'" nz-tooltip nzTooltipTitle="Edit" nzType="edit"
                                    nzTheme="twotone"></nz-icon>

                                <!-- Generate Quiz Result button -->
                                <ng-container *ngSwitchCase="'gen'">
                                    <nz-icon *ngIf="data.status !=='published'" nz-tooltip
                                        nzTooltipTitle="Generate Quiz Winner" nzType="trophy"
                                        nzTheme="twotone"></nz-icon>
                                </ng-container>

                                <!-- Delete button -->
                                <nz-icon *ngSwitchCase="'danger'" nz-tooltip nzTooltipTitle="Delete" nzType="delete"
                                    [nzTwotoneColor]="'#ff4d4f'" nzTheme="twotone"></nz-icon>
                            </ng-container>
                        </button>
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </tbody>
</nz-table>
<!-- Custom Total Template -->
<ng-template #totalTemplate let-range="range" let-total>
    Showing {{ range[0] }} - {{ range[1] }} of {{ total }} items
</ng-template>